/**
 * Created by asiulik on 20.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../core/cookies', '../store/favouriteStore'], function($, _, EventEmitter, CookiesHelper, FavouriteStore){


    var config = {
        calculatorOverlaySelector: "#shareOverlay",
        sliderTriggerSelector: "[data-share-overlay-trigger]",
        formSelector: ".favourites__share-form",
        shareLinksSelector: ".favourites__share-links a"
    };

    function OverlayShare(overlayInstance){
        this.overlay = overlayInstance;
    }

    OverlayShare.prototype = _.clone(EventEmitter.prototype);

    OverlayShare.prototype.init = function(){
        this.favouritesStore = new FavouriteStore();

        this.$triggerElements = $(config.sliderTriggerSelector);
        this.$calculatorOverlay = $(config.calculatorOverlaySelector);

        this.bindEvents();

        var favourites = this.favouritesStore.getFavourites();
        if (favourites && favourites.content && favourites.content.products.length > 0) {
            this.$triggerElements.removeAttr('disabled');
        }
    };

    OverlayShare.prototype.bindEvents = function(){

        var _this = this;

        this.$triggerElements.on({
            click: function(e){
                e.preventDefault();

                var $this = $(this);

                var favs = _this.favouritesStore.getFavourites();

                if ( !!favs ) {
                    _this.initShareForm();

                    if ( favs['content']['products'].length === 0 ) {
                        _this.emit('overlay:share:favsBeforeOpen')
                    } else {
                        if ( favs['content']['products'].length > 0 ) {

                            var identifierToVerify = $('.teaser--product .favourites__action__wrapper').data('fav-id');
                            var productExistInFavs = false;

                            favs['content']['products'].filter(function(element, index, array) {
                                if (element.identifier == identifierToVerify) {
                                    productExistInFavs = true;
                                }
                            });

                            if ( productExistInFavs ) {
                                // _this.openTerminOverlay($this);
                                _this.openTerminOverlay();
                            } else {
                                _this.emit('overlay:share:favsBeforeOpen')
                            }
                        }

                    }
                }

            }
        })


    };

    OverlayShare.prototype.openTerminOverlay = function(){
        this.overlay.openOverlay(
            this.$calculatorOverlay
        );
    };

    OverlayShare.prototype.postAddOpenTerminOverlay = function(){
        this.overlay.openOverlay(
            this.$calculatorOverlay
        );
    };

    // OverlayShare.prototype.fillHiddenField = function() {
    //
    //     var favourites = this.favouritesStore.getFavourites();
    //
    //     $(config.terminOverlaySelector).find("input[id$='favourite-id']").val(favourites.general.code);
    //     $(config.terminOverlaySelector).find("input[id$='favourite-value']").val(JSON.stringify(favourites));
    //
    // }

    OverlayShare.prototype.initShareForm = function () {
        var favourites = this.favouritesStore.getFavourites();

        if (!favourites || !favourites.general || !favourites.general.bookmark) return;

        var form = document.querySelector(config.formSelector);
        if (!form) {
            return;
        }
        var bookmarkUrl = favourites.general.bookmark;

        var bookmarkField = form.querySelector('input[name *= "bookmark"]');

        if (bookmarkField.classList.contains('initialised')) return;

        bookmarkField.value = bookmarkUrl;

        // Set label to active
        bookmarkField.previousElementSibling.classList.add('active');
        bookmarkField.classList.add('initialised');

        // Add copy to clipboard button
        var copyButton = document.createElement('button');
        copyButton.classList.add('bookmark-copy-button');
        copyButton.type = 'button';
        copyButton.innerHTML = '<svg aria-hidden="true" data-prefix="far" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 00348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 00-14.059-33.941zM266 464H54a6 6 0 01-6-6V150a6 6 0 016-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 01-6 6zm128-96H182a6 6 0 01-6-6V54a6 6 0 016-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 01-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 011.757 4.243V112z"/></svg>';
        copyButton.addEventListener('click', function (e) {
            e.preventDefault();
            bookmarkField.disabled = false;
            bookmarkField.select();
            console.log(document.execCommand('copy'), 'copy result');
            bookmarkField.blur();
            bookmarkField.disabled = true;
        }, true);
        bookmarkField.after(copyButton);

        // Update share links
        var shareLinks = document.querySelectorAll(config.shareLinksSelector);
        for (var i = 0; i < shareLinks.length; i++) {
            shareLinks[i].href = shareLinks[i].href.replace('#bookmark#', bookmarkUrl);
        }
    }

    return OverlayShare
});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlayShare.js